export default {
      id: "ic_link_copied-usage",
      viewBox: "0 0 55 55",
      url: "/" + "images/icons.3.109.2.svg#ic_link_copied-usage",
      toString: function () {
        return this.url;
      }
    }